import { useEffect, useRef } from "react";
import { Error } from "@narmi/design_system";
import styles from "./ExpandingTextArea.module.css";

export function ExpandingTextArea({
  label,
  value,
  error,
  onChange,
  className = "",
}: {
  label: string;
  value: string;
  error: string | null;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
}) {
  const textInputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textInputRef.current) {
      // Adjust the height of the textarea to fit the content
      textInputRef.current.style.height = "";
      textInputRef.current.style.height = textInputRef.current.scrollHeight + "px";
    }
  }, [value]);

  return (
    <>
      <textarea
        ref={textInputRef}
        className={`${styles.expandingTextArea} ${className} ${error ? styles.error : ""}`}
        placeholder={label}
        value={value}
        onChange={onChange}
      />
      {error && <Error error={error} />}
    </>
  );
}
